import type { ModalProps } from 'antd';
import Content from 'views/Dashboard/PerfReport/components/AssistantPerf/Content';
import { FilterProvider } from 'views/Dashboard/PerfReport/components/AssistantPerf/Filter';
import { JustRightHeightModal } from 'components/styled/scoped';
import styled from '@emotion/styled';
const Container = styled.div`
  height: calc(94vh - 111px);
`;

interface OnlineDataModalProps extends Omit<ModalProps, 'footer' | 'width'> {}
function OnlineDataModal({ visible, ...rest }: OnlineDataModalProps) {
  return (
    <JustRightHeightModal width="88.47223%" centered visible={visible} footer={null} {...rest}>
      <FilterProvider initialValue={{ conversationType: 2 }}>
        <Container>
          <Content selType="realTime" />
        </Container>
      </FilterProvider>
    </JustRightHeightModal>
  );
}
export default OnlineDataModal;
